let Messages = require('./messages');

module.exports = {
	mixins: [Messages],

	data() {
		return {
			cancelRequest: false
		}
	},

	methods: {
		sendRequest: function(url, method = 'get', callback = null, data = {}) {

			// cancel existing call
			if(this.cancelRequest) {
				this.cancelRequest.cancel();
			}

			this.cancelRequest = axios.CancelToken.source();

			// we need this until spark-bootstrap fixes their catch-all to ignore axios cancels
			// we store and remove the interceptors to restore after our request
			let responseInterceptors = window.axios.interceptors.response.handlers;
			window.axios.interceptors.response.handlers = [];

			axios({
				method: method,
				url: url, 
				data: data,
				cancelToken: this.cancelRequest.token
			})
			.then(response => {
				if(!response) {
					return false;
				}

				let message = response.data.message,
				    data    = response.data.data;
				
				if(callback != null) {
					callback(data, message);
				} else {
					this.displayMessage(message.content, message.type);
				}
			})
			.catch(error => {
				this._handleError(error);
		  	});

			// restore axios interceptors
		    window.axios.interceptors.response.handlers = responseInterceptors;
		},

		_handleError: function(error) {
			// ignore cancelled axios requests and errors caused by navigation
			if (axios.isCancel(error) || !error.response) {
				return;
			}

			if(error.response.status === 401) {
				this.displayMessage('Oops, you must be logged in to perform this action. You will be redirected shortly.', 'error');

				setTimeout(() => { window.location = '/login'; }, 3000);
			} else if(error.response.status === 402) {
				this.displayMessage('Oops, you must have an active subscription to perform this action. You will be redirected shortly.', 'error');

				setTimeout(() => { window.location = '/settings#/subscription'; }, 3000);
			} else {
		    	this.displayMessage('Oops, something went wrong. Please try again.', 'error');
		    }
		}
	}
};
